import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get area
export const getArea = createAsyncThunk("area/getArea", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getArea({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all area
export const getAllArea = createAsyncThunk("area/getAllArea", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllArea();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("area/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("area/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("area/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageArea({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get particular page
export const getAreaById = createAsyncThunk("area/getAreaById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getAreaById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create area
export const createArea = createAsyncThunk("area/createArea", async (param, { rejectWithValue }) => {
  const { name, streetAddress, ward, isActive } = param;
  try {
    const body = JSON.stringify({ name, streetAddress, ward, isActive });
    const { data } = await API.createArea(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateArea = createAsyncThunk("area/updateArea", async (param, { rejectWithValue }) => {
  const { id, values } = param;
  const { name, streetAddress, ward, isActive } = values;
  try {
    const body = JSON.stringify({ name, streetAddress, ward, isActive });
    const { data } = await API.updateArea(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("area/handleSearch", async (param, { rejectWithValue }) => {
  const { search, rowsPerPage } = param;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
